import format from 'date-fns/format';
export function formatDateISO(value) {
    const date = ensureDate(value);
    return date.toISOString();
}
export function formatDate(value, formatString = 'MMMM do yyyy') {
    const date = ensureDate(value);
    return format(date, formatString);
}
export function ensureDate(value) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date;
}
function calculateDiffInDays(a, b) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}
export function getDateDiff(start, end) {
    let diff = calculateDiffInDays(ensureDate(start), ensureDate(end));
    const years = Math.floor(diff / 365);
    const year_text = years === 1 ? 'year ' : 'years';
    diff %= 365;
    const months = Math.floor(diff / 30);
    const mon_text = months <= 1 ? 'month' : 'months';
    const days = diff % 30;
    const day_text = days <= 1 ? 'day' : 'days';
    return `${years !== 0 ? `${years} ${year_text}` : ''}${months !== 0 ? ` ${months} ${mon_text}` : ''}${days !== 0 ? ` ${days} ${day_text}` : ''}`;
}
export function equalDates(startDate, endDate) {
    const sd = ensureDate(startDate);
    const ed = ensureDate(endDate);
    return sd.toDateString() === ed.toDateString();
}
